import { render, staticRenderFns } from "./BtnStatusLeilao.vue?vue&type=template&id=2a263f74&"
import script from "./BtnStatusLeilao.vue?vue&type=script&lang=js&"
export * from "./BtnStatusLeilao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports